import React from 'react';
import { useNavigate } from 'react-router-dom';
import FAQSection from '../components/FAQSection';
import Navbar from '../components/Navbar';
import { AlignVerticalJustifyCenter } from 'lucide-react';

export default function Upgrade() {
  const navigate = useNavigate();

  const benefits = [
    { icon: '🚀', title: 'Maximum Daily Plays' },
    { icon: '📊', title: 'Advanced Streak & Achievement Insights' },
    { icon: '🏅', title: 'Full Access to Buddy Bot' },
    { icon: '🎮', title: 'New Brain Games & Challenges' },
    { icon: '🤝', title: 'Friends & Team Leaderboards' },
  ];
  const plans = [
    { label: 'Pro Brainies', price: 'FREE', Highlight: true },
    { label: '30 Days', price: '₹999', popular: true },
    { label: '1 Year', price: '₹9999' },

  ];

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-yellow-50 to-pink-100 px-6 py-12 text-center relative">
        <div className="relative mb-12">
          <h1 className="text-5xl font-extrabold text-purple-700 mb-4">
            Become a Pro Brainy <span className="text-yellow-500">💎</span>
          </h1>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Get unlimited book uploads, instant summaries, AI quizzes, progress tracking, brain games, and your own learning coach—only on BrainyBuddy.in!
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 max-w-5xl mx-auto mb-16">
          {benefits.map((b, i) => (
            <div
              key={i}
              className="group relative flex flex-col items-center bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all"
            >
              <div className="flex items-center justify-center w-16 h-16 bg-purple-100 text-4xl rounded-full mb-4 group-hover:bg-purple-200 transition">
                {b.icon}
              </div>
              <p className="font-semibold text-purple-800 group-hover:text-purple-900 transition">
                {b.title}
              </p>
            </div>
          ))}
        </div>

        <h2 className="text-3xl font-bold text-purple-700 mb-8">
          Choose Your Plan
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-4xl mx-auto mb-12">
          {plans.map(({ label, price, popular }) => (
            <div
              key={label}
              className={`relative bg-white p-8 rounded-3xl shadow-xl border-2 transition-transform transform hover:scale-105 ${
                popular ? 'border-yellow-400 ring-2 ring-yellow-200' : 'border-purple-200'
              }`}
            >
              {popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-white px-4 py-1 rounded-full text-sm font-bold shadow-md">
                  Most Popular
                </div>
              )}
              <p className="font-bold text-xl text-purple-800 mb-2">{label}</p>
              <p className="text-3xl font-extrabold text-gray-900 mb-6">{price}</p>
              <button
                onClick={() => navigate('/contact')}
                className="mt-4 w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3 rounded-lg font-semibold shadow-md hover:from-purple-700 hover:to-indigo-700 transition-all"
              >
                Activate Now
              </button>
            </div>
          ))}
        </div>

        <button
          onClick={() => navigate('/contact')}
          className="inline-block bg-purple-600 text-white px-10 py-3 rounded-full font-bold hover:bg-purple-700 transition animate-bounce"
        >
          Contact Us to Activate 🔐
        </button>

        <div className="mt-16 px-4">
          <FAQSection />
        </div>
      </div>
    </>
  );
}
